export default __webpack_public_path__ + "static/media/summary-white.a4a3b7fc.svg";